const Menu = [
  {
    title: 'Dashboard',
    group: 'apps',
    icon: 'dashboard',
    name: 'Dashboard',
  },
  {
    title: 'Settings',
    group: 'apps',
    name: 'Settings',
    icon: 'fa-sliders-h',
  },
]

export default Menu
